// Cuánto dura un video remoto, leyendo sólo sus metadatos en el navegador (un `<video>` con
// `preload="metadata"`: baja el índice, no el video). Lo usa la card de video del chat
// cuando el video de referencia no trae su duración — muchos videos de Creaciones no la
// guardan (ADR-2026-09-25-editar-un-video-conserva-su-duracion).
export function duracionDeVideoPorUrl(url: string, timeoutMs = 15_000): Promise<number | null> {
  return new Promise((resolver) => {
    const v = document.createElement('video');
    let listo = false;
    const terminar = (d: number | null) => {
      if (listo) return;
      listo = true;
      v.removeAttribute('src');
      v.load();
      resolver(d);
    };
    const t = window.setTimeout(() => terminar(null), timeoutMs);
    v.preload = 'metadata';
    v.muted = true;
    v.onloadedmetadata = () => {
      window.clearTimeout(t);
      terminar(Number.isFinite(v.duration) && v.duration > 0 ? v.duration : null);
    };
    v.onerror = () => {
      window.clearTimeout(t);
      terminar(null);
    };
    v.src = url;
  });
}
